import { PageHeader } from '@ant-design/pro-components';
import { Divider } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useMemo } from 'react';
import { ModalProvider } from '@workspace/design-system/src/components';
import DefaultLayout from '@src/components/DefaultLayout';
import TemplateTable from './TemplateTable';
import { useTemplateController } from '@src/hooks/template/use-template-controller';
import { planTypesToPricingTiers } from '@src/hooks/template/utils';
import type { ProjectTemplateInfoResponseModel } from '@uniquegood/realworld-admin-interface';
import type { PricingTier } from '@src/hooks/template/utils';

// API 응답을 TemplateTable에 맞는 형식으로 변환
interface TemplateItem {
    id: string;
    order: number;
    imageUrl: string;
    name: string;
    description: string;
    pricingTiers: PricingTier[];
    studioUrl?: string;
}

const convertTemplateToItem = (template: ProjectTemplateInfoResponseModel): TemplateItem => {
    return {
        id: template.id,
        order: template.order,
        imageUrl: template.imageUrl || '',
        name: template.name,
        description: template.description || '',
        pricingTiers: planTypesToPricingTiers(template.planTypes),
    };
};

export default function StudioPlanTemplate() {
    const {
        templates,
        isLoading,
        handleDragEnd,
        handlePricingTierUpdate,
        handleStudioOpen,
        openPricingTierModal,
        openContentDetailModal,
    } = useTemplateController();

    const templateItems = useMemo(() => templates.map(convertTemplateToItem), [templates]);

    return (
        <ModalProvider>
            <DefaultLayout>
                <PageHeader title="요금제별 템플릿 설정" style={{ margin: '16px 20px 0px 20px' }} />
                <Divider />
                <Content style={{ padding: '0 24px', margin: '0px 20px' }}>
                    <div className="px-4 py-6 sm:px-0">
                        <div className="bg-white rounded-[24px] p-10 shadow-sm">
                            <TemplateTable
                                data={templateItems}
                                isLoading={isLoading}
                                onDragEnd={handleDragEnd}
                                onPricingTierUpdate={handlePricingTierUpdate}
                                onStudioOpen={handleStudioOpen}
                                onSettingClick={(item) => {
                                    const template = templates.find((t) => t.id === item.id);
                                    if (template) {
                                        openPricingTierModal(template);
                                    }
                                }}
                                onContentClick={(item) => {
                                    const template = templates.find((t) => t.id === item.id);
                                    if (template) {
                                        openContentDetailModal(template);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </Content>
            </DefaultLayout>
        </ModalProvider>
    );
}
